import { render, staticRenderFns } from "./exits.vue?vue&type=template&id=a2bf69ec&scoped=true"
import script from "./exits.vue?vue&type=script&lang=js"
export * from "./exits.vue?vue&type=script&lang=js"
import style0 from "./exits.vue?vue&type=style&index=0&id=a2bf69ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf69ec",
  null
  
)

export default component.exports